import { Stack, Text, View, XStack } from "tamagui";
import { Button } from "../../../../components/design-system";
import { Platform, Image } from "react-native";
import * as Haptics from "expo-haptics";
import mixpanel from "../../../../../mixpanel";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { ClubNavigatorParamList } from "../../../../navigators/ClubNavigator";
import { supabase } from "../../../../../lib/supabase";
import { useApiQuery } from "../../../../../lib/api";
import { Loader } from "../../../../components/design-system/Loader";

type PartnerItem = {
  id: number;
  name: string | null;
  image_url: string | null;
};

export const PartnersList = () => {
  const { data, isLoading, error } = useApiQuery<{ partners: PartnerItem[] }>(
    ["partners"],
    "/api/v1/partners"
  );

  const partners = data?.partners ?? [];

  const navigation = useNavigation<NavigationProp<ClubNavigatorParamList>>();

  const onPartnerPress = (partnerId: string, name: string) => {
    if (Platform.OS === "ios") Haptics.selectionAsync();

    mixpanel.track("Partner Pressed", { partner: name });

    navigation.navigate("Partner", { partnerId });
  };

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return (
      <Text color="$red10" textAlign="center" py="$4">
        Failed to load partners.
      </Text>
    );
  }

  return (
    <Stack
      flexDirection={"row"}
      flexWrap={"wrap"}
      justifyContent="space-between"
      gap="$2"
      columnGap="$2"
    >
      {partners.map((partner) => {
        const imageUrl = partner.image_url
          ? supabase.storage.from("partners").getPublicUrl(partner.image_url)
              ?.data?.publicUrl
          : null;

        return (
          <View w={"48%"} key={partner.id}>
            <Button
              bg="white"
              p={0}
              mb="$2"
              pressStyle={{
                scaleX: 0.99,
                scaleY: 0.99,
                bg: "white",
                shadowOffset: { height: 1, width: 1 },
                shadowOpacity: 0.7,
              }}
              {...{
                shadowColor: "black",
                shadowOffset: { width: 2, height: 2 },
                shadowOpacity: 0.9,
                shadowRadius: 0,
              }}
              onPress={() =>
                onPartnerPress(String(partner.id), partner.name ?? "")
              }
            >
              <XStack p="$4" justifyContent="center" alignItems="center">
                {imageUrl ? (
                  <Image
                    style={{
                      width: "100%",
                      objectFit: "contain",
                      minHeight: 100,
                    }}
                    source={{ uri: imageUrl }}
                    resizeMode="contain"
                  />
                ) : (
                  <Text fontFamily="$heading" fontSize={16} textAlign="center">
                    {partner.name}
                  </Text>
                )}
              </XStack>
            </Button>
          </View>
        );
      })}
    </Stack>
  );
};
